import vue from 'vue';

export default {
    error(message /*string*/) {
        vue.$snotify.error(message);
    },
    success(message /*string*/) {
        vue.$snotify.success(message);
    },
};
